export default __webpack_public_path__ + "static/media/s1-icon-4.93c98a90.svg";